module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "/portfolio"
  siteTitle: 'Qmon Adventures', // Navigation and Site Title
  siteTitleAlt: 'Qmon', // Alternative Site title for SEO
  siteTitleShort: 'Qmon', // short_name for manifest
  siteHeadline: 'Yacht rentals in the Caribbean', // Headline for schema.org JSONLD
  siteUrl: 'https://www.qmonadventures.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logo.png', // Used for SEO and manifest
  siteDescription: 'Yacht rentals in the British Virgin Islands in the Caribbean. Luxury charters and an unforgettable sailing experience in paradise',
  author: 'Qmon Adventures', // Author for schema.org JSONLD
  keyword: 'Charter, rentals, bvi, british virgin islands, chartering, rent, boat, Yacht, Vacation, Luxury, Holiday, Superyacht, Megayacht, Destination, Crewed Yacht, Yacht Rental, Yacht Hire, Yachting, Super Yacht, Mega Yacht',
  // siteFBAppID: '123456789', // Facebook App ID - Optional
  // userTwitter: '@cara', // Twitter Username
  ogSiteName: 'Qmon Adventures', // Facebook Site Name
  ogLanguage: 'en_US', // Facebook Language
  // googleAnalyticsID: 'UA-47519312-5',

  // Manifest and Progress color
  themeColor: '#6C82FF',
  backgroundColor: '#FFFFFF',
}
